var myLazyLoad;
var usp_parts = 100;
var usp_counter;

//initiate
$(window).load(function () {
    //Set lazyload
    myLazyLoad = new LazyLoad();

    postSuccessPosition();
});

$(window).resize(function () {

    $('.inspiratie-foto-slider').height($('.inspiratie-foto-slider li img').height());

});

$(document).ready(function () {

    setInspiration();

    set_form_values('.newsLetterForm');

    setMenu();

    setFiltertext();

    setFlexslider();

    setReadmore();

    setPretty();

    setUSP();

    formValidation();

    //limit color choise
    var limit = 5;
    $('.coloritem-checkbox input').on('change', function (evt) {
        if ($('.coloritem-checkbox input:checked').length > limit) {
            this.checked = false;
            $(this).parent().removeClass('checked');
        } else {
            if (!$(this).parent().hasClass('checked')) {
                $(this).parent().addClass('checked');
            } else {
                $(this).parent().removeClass('checked');
            }
        }

    });

    $(".checkbox-group-element").on('change', function () {
        var parent = $(this).parents('.checkbox-group');

        /* declare an checkbox array */
        var chkArray = [];

        /* Check if it was checked */
        $(".checkbox-group-element:checked", parent).each(function () {
            chkArray.push($(this).val());
        });

        /* we join the array separated by the comma */
        var selected;
        selected = chkArray.join(',');

        /* update value */
        $('.checkbox-group-final', parent).val(selected);
    });

    $('.hidegroup-trigger input').on('change', function () {
        if ($(this).is(":checked")) {
            $('.hidegroup-element').show();
        } else {
            $('.hidegroup-element').hide();
        }
    });

    //////////////////////////////////////////////////

    setProductfilter();

    getProductfilter();

    productWrapper();

    tabs();

    setLoadMoreNews();

    link_slider();

    order();
});


function formValidation() {
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {

            form.addEventListener('submit', function(event) {
                // console.log('submit', form.checkValidity(), form.name);

                form.classList.add('was-validated');

                if(form.checkValidity() === false) {
                    $('html, body').animate({
                        scrollTop: ($('.invalid-feedback:first').offset().top - 120)
                    }, 300);
                    event.preventDefault(); event.stopPropagation();
                }
            }, false);
        });
    }, false);
};


function checkbox_value(data) {
    /* declare an checkbox array */
    var chkArray = [];

    /* look for all checkboes that have a class 'chk' attached to it and check if it was checked */
    $("[data-checkbox='" + data + "']:checked").each(function () {
        chkArray.push($(this).val());
    });

    /* we join the array separated by the comma */
    var selected;
    selected = chkArray.join(',');

    /* update value */
    $('[name="' + data + '"]').val(selected);
}

function tabs() {
    $('[data-tab]').on('click', function () {
        var $selected_tab = $(this);
        var $selected_tab_id = $selected_tab.attr('data-tab');
        var $parent = $(this).parents('.tabs');

        $('.tabs-nav li', $parent).removeClass('active');
        $selected_tab.parent().addClass('active');

        $('[data-tabcontent]', $parent).hide();
        $('[data-tabcontent="' + $selected_tab_id + '"]').show();
    });
}

function productWrapper() {
    $('#products').on('click', '.product', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) {
            $('#productFiche').find('.closer').click();
        } else if ($('#productFiche').length) {
            var pr = $(this);
            var offsetTop = pr.offset().top;
            var offsetTopCurrent = $('.productWrapper .selected:first').offset().top;
            if (offsetTop > offsetTopCurrent) {
                offsetTop -= $('#productFiche').height();
            }

            $('body, html').animate({'scrollTop': offsetTop - 10}, 500);
            $('#productFiche').animate({'height': '0'}, 500, function () {
                $('#productFiche').remove();
                $('.product').removeClass('selected');
                pr.addClass('selected');
                $('.productWrapper').removeClass('selectedContent');
                pr.parents('.productWrapper').addClass('selectedContent');
                loadProduct(pr);
            });
        } else {
            $(this).addClass('selected');
            $(this).parents('.productWrapper').addClass('selectedContent');
            loadProduct($(this));
        }
    });
}

function updateProductIndex() {
    $('#products .product').attr('data-index', '');
    $('#products .product:visible').each(function (index) {
        $(this).attr('data-index', index);
    });
}

function loadProduct(me) {
    //set loader
    $('#loader2').remove();
    me.find('.productTitleWrapper:first').append('<img src="/media/img/loader2.gif" id="loader2" class="loader2" />');
    //
    var number = Math.floor(parseFloat(me.parents('.maxWrapper').width() / 310));
    updateProductIndex();
    var index = me.attr('data-index');
    var row = Math.floor(index / number) + 1;
    var indexlast = (number * row) - 1;
    var reallast = $('.product:visible').last().attr('data-index');
    if (indexlast > reallast) {
        indexlast = reallast;
    }
    $('.product[data-index=' + indexlast + ']').after($('<div class="productFiche" id="productFiche"></div>'));
    $.ajax({
        type: "post",
        url: "/custom/ajax.php",
        data: {
            m: 'getProductFiche',
            id: me.attr('data-product'),
            lang: $('html').attr('lang'),
            active: $('body').attr('data-boasoftid'),
        },
        complete: function (data) {
            //track event
            if (typeof trackEvent === 'function') {
                trackEvent('load product', me.attr('href'));
            }
            //
            $('#productFiche').html(data.responseText).addClass('height');
            var offsetTop = me.offset().top;
            $('body, html').animate({'scrollTop': offsetTop - 10}, 250);

            //facebook sharer
            $('.sharer').on('click', function () {
                var name = $(this).attr('data-name');
                var link = $(this).attr('data-link');
                var caption = $(this).attr('data-caption');
                var picture = $(this).attr('data-picture');
                var description = $(this).attr('data-description');
                shareOnFacebook(name, link, caption, picture, description);
            });

            $('.closer').bind('click', function () {
                $('#productFiche').animate({'height': '0'}, function () {
                    $('#productFiche').remove();
                    $('.product').removeClass('selected');
                    $('.productWrapper').removeClass('selectedContent');
                });
            });

            //destroy loader
            $('#loader2').remove();

            //set pretty
            $('.mogelijkeAfwerkingen:first .pop').prettyPhoto({
                social_tools: false,
                show_title: false,
                overlay_gallery: false,
                theme: 'facebook',
                opacity: 0.8,
                changepicturecallback: function () {
                    if (typeof trackEvent === 'function') {
                        trackEvent('maximize image', $('#fullResImage').attr('src'));
                    }
                },
            });
            $('.productphotos:first .pop').prettyPhoto({
                social_tools: false,
                show_title: false,
                overlay_gallery: false,
                theme: 'facebook',
                opacity: 0.8,
                changepicturecallback: function () {
                    if (typeof trackEvent === 'function') {
                        trackEvent('maximize image', $('#fullResImage').attr('src'));
                    }
                },
            });
            $('.productphotoright:first .pop').prettyPhoto({
                social_tools: false,
                show_title: false,
                overlay_gallery: false,
                theme: 'facebook',
                opacity: 0.8,
                changepicturecallback: function () {
                    if (typeof trackEvent === 'function') {
                        trackEvent('maximize image', $('#fullResImage').attr('src'));
                    }
                },
            });


        }
    });
}

function order() {
    if ($('.order-item').length) {
        $('.order-item').change(function () {

            //Set orderlist
            $list = "";
            $total = 0;
            $subtotal = 0;

            $(".order-item").each(function (index) {
                if ($(this).val() > 0 && $(this).val() != '') {
                    $price = $(this).attr('data-price');
                    $count = $(this).val();
                    $list += $(this).attr('name') + ": " + $count + ' X (&euro; ' + $price + '/stuk)\n';
                    $subtotal += (parseFloat($price) * parseFloat($count));
                }
                if ($subtotal) {
                    $total = $subtotal + parseFloat($('#orderTransport').val());
                }
            });

            $('#orderList').val($list);
            $('#orderSubtotal').val($subtotal.toFixed(2));
            $('#orderSubtotalLabel').html($subtotal.toFixed(2).replace('.', ','));
            $('#orderTotal').val($total.toFixed(2));
            $('#orderTotalLabel').html($total.toFixed(2).replace('.', ','));
        });
        $('.formcontact:first').on('change', 'select', function () {
            var country = $(this).val();
            var tc = '';
            if (country.substring(0, 2).toLowerCase() == 'be') {
                tc = $('#orderTransport').data('be');
            } else {
                tc = $('#orderTransport').data('int');
            }
            setOrderTransport(tc, country);
        });
        $('.formcontact:first select').change();
    }
}

function setOrderTransport(tc, country) {
    $('#orderTransport').val(tc);
    $('#orderTransportLabel').html(tc.toString().replace('.', ','));
    $('#transportCountry').html(country);
    $('.order-item:first').change();
}


function setPretty() {
    //set prettyPhoto
    if ($('.mogelijkeAfwerkingen:first .pop').length) {
        $('.mogelijkeAfwerkingen:first .pop').prettyPhoto({
            social_tools: false,
            show_title: false,
            overlay_gallery: false,
            theme: 'facebook',
            opacity: 0.8,
            changepicturecallback: function () {
                if (typeof trackEvent === 'function') {
                    trackEvent('maximize image', $('#fullResImage').attr('src'));
                }
            },
        });
        $('.productphotos:first .pop').prettyPhoto({
            social_tools: false,
            show_title: false,
            overlay_gallery: false,
            theme: 'facebook',
            opacity: 0.8,
            changepicturecallback: function () {
                if (typeof trackEvent === 'function') {
                    trackEvent('maximize image', $('#fullResImage').attr('src'));
                }
            },
        });
        $('.productphotoright:first .pop').prettyPhoto({
            social_tools: false,
            show_title: false,
            overlay_gallery: false,
            theme: 'facebook',
            opacity: 0.8,
            changepicturecallback: function () {
                if (typeof trackEvent === 'function') {
                    trackEvent('maximize image', $('#fullResImage').attr('src'));
                }
            },
        });

    } else if ($('.pop').length) {

        $('.pop').prettyPhoto({
            social_tools: false,
            show_title: false,
            overlay_gallery: false,
            theme: 'facebook',
            opacity: 0.8,
            changepicturecallback: function () {
                if (typeof trackEvent === 'function') {
                    trackEvent('maximize image', $('#fullResImage').attr('src'));
                }
                var descr = $('.pp_description').text();
                if (descr.includes('||')) {
                    var explode = descr.split('||');
                    if (explode[1]) {
                        var link = '<a href="' + explode[1] + '">' + explode[0] + '</a>';
                        $('.pp_description').html(link);
                    }
                }
            },
        });

    }
}

function setFiltertext() {
    if ($('.filtertext, .filter-text').length) {
        $('.filtertext, .filter-text').find('p').each(function (key) {
            if (key > 1) {
                $(this).hide();
            }
        });
        $('.filtertext, .filter-text').find('.more').show();
        $('.filtertext, .filter-text').find('.more').click(function () {
            $(this).hide();
            $(this).parent().find('p').show('fast');
        });
    }
}

function shareOnFacebook(name, link, caption, picture, description) {
    FB.ui({
        method: 'feed',
        name: name,
        link: link,
        caption: caption,
        picture: picture,
        description: description
    }, function (response) {
        if (response && response.post_id) {
        } else {
        }
    });
}

function setLoadMoreNews() {
    // LOAD MORE BLOG ARTICLES
    if ($('#load-more-blogs').length > 0) {

        $('#blog-list').on('click', '#load-more-blogs', function () {

            if (!$(this).hasClass('disabled')) {

                $(this).text('Loading...');
                var ele = $(this).parents('ul');

                // Is er een categorie?
                if ($(this).data('cat')) {
                    var catID = $(this).data('cat');
                } else {
                    var catID = null;
                }

                // Is er een tag?
                if ($(this).data('tag')) {
                    var tag = $(this).data('tag');
                } else {
                    var tag = null;
                }

                var urlPath = $(this).data('url');

                $.ajax({
                    url: '/custom/ajax.php/',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        m: 'loadMoreNews',
                        page: $(this).data('page'),
                        cat: catID,
                        tag: tag,
                        url: urlPath
                    },
                    success: function (response) {
                        if (response) {
                            ele.parent('div').remove();
                            ele.remove();
                            $('#blog-list').append(response);
                        }
                    }
                });
            }
        });
    }
}

function link_slider() {
    $('.link-slider').each(function (key, item) {
        var $slickElement = $(this);

        $slickElement.slick({
            dots: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
            infinite: true,
            fade: false,
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 2000,
            swipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1320,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });

        /*
		 .on('beforeChange', function(event, slick, currentSlide, nextSlide){
		 $('.equal-height').matchHeight();
		 })
         */
    });
};

function setInspiration() {
    //ISOTOPE
    if ($('.isotope').length) {
        var $grid = $('.grid').isotope({
            // options...
            itemSelector: '.grid-item',
            percentPosition: true,
            masonry: {
                // use element for option
                columnWidth: '.grid-sizer'
            }
        });
        // layout Isotope after each image loads
        $grid.imagesLoaded().progress(function () {
            $grid.isotope('layout');
        });
        //
        //FILTER BUTTONS
        $('.inspiration-filters').on('click', '.inspiration-filter', function () {
            $('.inspiration-filters .inspiration-filter').removeClass('active');
            $(this).addClass('active');
            var filterValue = $(this).attr('data-cat');
            $grid.isotope({filter: filterValue});
            //
            //FIX GALLERY
            if (filterValue == '*') {
                $('.grid-item a').attr('rel', 'gal[]');
                //
                setPretty();
            } else {
                $(".grid-item a").each(function (index) {
                    $gal = $(this).attr('data-gal');
                    $(this).attr('rel', $gal);
                });
                //
                setPretty();
            }
        });
        //
        //
        $('.inspiration-filter.active').click();
    }
}

function getProductfilter() {
    if ( $('.filters:first').length > 0) {
        var activeFilter = $('.filters:first').find('.active');
        var filterList = [];
        activeFilter.each(function () {
            filterList.push($(this).attr('data-filter'));
        });
        var filterValue = filterList.join('');
        if ($('.filters:first .waterproof.filterpart').length > 0 && $('.filters:first .waterproof.filterpart input').val() !== '0') {
            filterValue = filterValue + '.water-' + $('.filters:first .waterproof.filterpart input').val();
        }
        filterValue!=='' ? filterProducts(filterValue) : $('.filters:first .clearfilter').hide('fast');
    }
}

function setProductfilter() {
    //ISOTOPE ALTERNATIVE
    var filter = $('.filters:first');
    if (filter.length) {
        filter.on('click', '.productfilter>li>a, .custom-tristate', function (e) {
            if (!$(this).hasClass('custom-tristate')) {
                $(this).parent().parent().find('.active').removeClass('active');
                $(this).addClass('active');
            }
            var activeFilter = filter.find('.active');
            var filterList = [];
            activeFilter.each(function () {
                filterList.push($(this).attr('data-filter'));
                setFilterLabel($(this));
            });
            var filterValue = filterList.join('');
            if ($('.waterproof.filterpart').length > 0 && $('.waterproof.filterpart input').val() !== '0') {
                filterValue = filterValue + '.water-' + $('.waterproof.filterpart input').val();
            }
            $('.colorSamples').css('display',filterValue.indexOf("color") >= 0 ? '' : 'none');
            filterProducts(filterValue);
            filterValue==='' ? $('.filters:first .clearfilter').hide('fast') : '';
            e.preventDefault();
        });
        var trikey = 1;
        filter.find('.clearfilter').on('click', function () {
            console.log('clear');
            $(this).hide();
            $(this).parent().parent().find('.active').removeClass('active');
            if ($('.waterproof.filterpart').length > 0 && $('.waterproof.filterpart input').val() !== '0') {
                $('.filters .waterproof.filterpart .custom-tristate').removeClass('yes no');
                $('.filters .waterproof.filterpart input').val('0');
                trikey = 1;
            }
            resetFilterLabels();
            filterProducts('.product');
        });
        if(filter.find('.waterproof')) {
            var tristatus = ['', 'yes', 'no'];
            filter.find('.waterproof').on('click', function() {
                $(this).find('.custom-tristate').attr('class', 'custom-tristate').addClass(tristatus[trikey]);
                $(this).find('input').val(trikey);
                if (trikey >= 2) { trikey = 0; } else { trikey++ }
            });
        }
    }
}

function setFilterLabel(that) {
    var h2 = that.parents('.filtermenu').find('h2>span');
    if (h2.attr('data-label')!==undefined) {
        that.parents('.filtermenu').length > 0 ? h2.text(that.text()) : h2.text(h2.attr('data-label')).append(img);
    }
}

function resetFilterLabels() {
    $('.filtermenu').find('h2').each(function () {
        if ($(this).find('span').attr('data-label') !== undefined) {
            $(this).find('span').text($(this).find('span').attr('data-label'));
        }
    });
}

function filterProducts(filterValue) {
    var products = $('#products');
    $('#productFiche').find('.closer').click();
    if (filterValue != '.product') {
        $('.filters:first .clearfilter').show('fast');
    }
    products.find('.product').not(filterValue).hide('fast');
    products.find('.product' + filterValue).show('fast');
    if (filterValue.includes("color-")) {
        products.find('.coloritem').not(filterValue).hide();
        products.find('.coloritem' + filterValue).show();
    } else {
        products.find('.coloritem').hide();
    }
    console.log(filterValue);
    setTimeout(function () {
        myLazyLoad.update()
    }, 500);
}

function set_form_values(id) {
    $(id + ' input[type=text], ' + id + ' textarea').each(function () {

        var input = $(this);
        var val = $(this).attr('val');

        if (input.val() == '') {
            input.val(val);
        }

        input.click(function () {
            if (input.val() == val) {
                input.val('');
            }
        });

        input.bind('blur', function () {
            if (input.val() == '') {
                input.val(val);
            }
        });
    });
}

function setFlexslider() {

    $('.flexslider').flexslider({
        animation: "slide",
        directionNav: false,
        controlNav: false,
        touch: false
    });

    $('.textslider').flexslider({
        animation: "slide",
        directionNav: false,
        sync: '.flexslider',
        touch: true
    });

    $('.inspiratie-tekst-slider').flexslider({
        animation: "fade",
        directionNav: false,
        slideshowSpeed: 7000,
        controlNav: false
    });
    $('.inspiratie-foto-slider').height($('.inspiratie-foto-slider li img').height());
    $('.inspiratie-foto-slider').flexslider({
        animation: "slide",
        directionNav: true,
        controlNav: false,
        sync: '.inspiratie-tekst-slider'
    });
}

function setMenu() {
    $('.main-menu > li > a').append("<span>.</span>");
    $('.main-menu > li > ul').wrap('<div class="submenuWrapper"><div class="maxWrapper"></div></div>');
    $('.submenuWrapper li').each(function () {
        if (!$(this).parents('.submenuWrapper').hasClass('filters')) {
            if ($(this).hasClass('active')) {
                $(this).parent().parent().parent().parent().first().addClass('active');
            }
        }
    });
    $('.menu-icon:first').click(function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.main-navigation').removeClass('show-nav');
            $('.main-header-wrapper').css({marginBottom: "0"});
            $('.main-navigation li.active .submenuWrapper').hide();
        } else {
            $(this).addClass('open');

            if ($('.main-navigation li.active .submenuWrapper').length > 0) {
                $('.main-header-wrapper').css({marginBottom: "140px"});
                $('.main-navigation li.active .submenuWrapper').show();
            }
            $('.main-navigation').addClass('show-nav');
        }

    });
}

function setReadmore() {
    //lees meer instelling
    $('.readmore').click(function () {
        if ($(this).attr('rel') != 'showExtra') {
            extraTxt = $(this).parent('p').parent('div').find('.leesmeer');
//			extraTxt.show('fast');
            extraTxt.css('height', 'auto');
            $(this).hide();
        } else {
            extraTxt = $(this).parent('p').parent('div').find('.leesmeer');
            extraTxt.hide('fast');
            extraTxt.css('height', '0');
            $(this).hide();
        }
    });
    $('.readless').click(function () {
        var extraTxt = $(this).closest('div');
        extraTxt.hide('fast');
        var readMore = $(this).parent('p').parent('div').parent('div').find('.readmore');
        readMore.show();
    });
    $('.leesmeer').hide();
}

function setUSP() {
    var counts = $('.usp-count');
    if (counts.length) {
        counts.each(function () {
            var max = parseInt($(this).text());
            var part = Math.ceil(max / usp_parts);
            $(this).attr('data-max', max);
            $(this).attr('data-part', part);
            $(this).text('0');
        });

        //USP is only function using scroll, move out of this function if no longer so
        $(window).scroll(function () {
            clearTimeout($.data(this, 'scrollTimer'));
            $.data(this, 'scrollTimer', setTimeout(function () {
                //on scroll end
                checkUSP();
            }, 100));
        });

        checkUSP();

    }
}

function checkUSP() {
    var usp = $('.usp:first');
    if (usp.length) {
        if (inViewport(usp)) {
            startUSP();
        }
    }
}

function updateUSP() {
    var counts = $('.usp-count.counting');
    if (counts.length) {
        counts.each(function () {
            var max = parseInt($(this).attr('data-max'));
            var part = parseInt($(this).attr('data-part'));
            var current = deformatNumber($(this).text());
            var newcount = current + part;
            if (newcount <= max) {
                $(this).text(formatNumber(newcount));
            } else {
                $(this).text(formatNumber(max));
                $(this).removeClass('counting');
            }
        });
    } else {
        clearTimeout(usp_counter);
    }
}

function startUSP() {
    var counts = $('.usp-count');
    clearTimeout(usp_counter);
    if (counts.length) {
        counts.addClass('counting');
        usp_counter = setInterval(updateUSP, 20);
    }
}

function formatNumber(number) {
    var string = number.toString();
    var strl = string.length;
    if (strl > 3) {
        string = [string.slice(0, strl - 3), string.slice(strl - 3)].join('.');
    }
    if (strl > 6) {
        string = [string.slice(0, strl - 6), string.slice(strl - 6)].join('.');
    }
    return string;
}

function deformatNumber(string) {
    return parseInt(string.replace('.', ''));
}

function inViewport(element) {
    var top_of_element = element.offset().top;
    var bottom_of_element = element.offset().top + element.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();
    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
        return true;
    } else {
        return false;
    }
}

function postSuccessPosition(){
    var p = $('#postsuccess');
    if(p.length){
        setTimeout(function(){$('html, body').scrollTop(p.offset().top);},250);
    }
}